import { render, staticRenderFns } from "./InviteStudentModal.vue?vue&type=template&id=7d0ed9e6&scoped=true&"
import script from "./InviteStudentModal.vue?vue&type=script&lang=js&"
export * from "./InviteStudentModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteStudentModal.vue?vue&type=style&index=0&id=7d0ed9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0ed9e6",
  null
  
)

export default component.exports